<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <div class="col-sm-12 text-right" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteVehicleModal">Delete Vehicle</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regNo)">
                                        <label>Registration No</label>
                                        <input type="text" maxlength="13" minlength="10" name="regNo" class="form-control" required v-model.lazy="vehicle.regNo" placeholder="Registration No" :readonly="true">
                                        <field-messages name="regNo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Registration no is a required field</div>
                                            <div slot="pattern">Registration no is invalid</div>
                                            <div slot="minlength">Minimum length of registration no is 10 character</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.capacity)">
                                        <label>Capacity (kg)</label>
                                        <input type="number" min="100" max="30000" name="capacity" class="form-control" required v-model.lazy="vehicle.capacity" placeholder="Capacity">
                                        <field-messages name="capacity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Capacity is a required field</div>
                                            <div slot="pattern">Capacity is invalid</div>
                                            <div slot="min">Minimum 100 kg Capacity</div>
                                            <div slot="max">Maximum 30000 kg Capacity</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                 <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dateCommissioning)">    
                                        <label for="dateAdded">Date of Commissioning</label>
                                        <date-picker required id="dateCommissioning" v-model="vehicle.dateCommissioning" lang="en" name="dateCommissioning" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="dateCommissioning" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Date of Commissioning is a required field</div>
                                            <div slot="pattern">Date of Commissioning is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                        <label>Geographical Area</label>
                                        <select v-model="vehicle.region" required name="region" class="form-control">
                                            <option disabled>Select G.A</option>
                                            <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerName)">
                                        <label>Transporter Name</label>
                                        <input type="text" name="ownerName" class="form-control" required v-model.lazy="vehicle.ownerName" placeholder="Transporter Name">
                                        <field-messages name="ownerName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Transporter name is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerContact)">
                                        <label>Transporter Contact No.</label>
                                        <input type="number" name="ownerContact" class="form-control" required v-model.lazy="vehicle.ownerContact" placeholder="Transporter contact number" pattern="[78965][0-9]{9}">
                                        <field-messages name="ownerContact" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Transporter contact no. is a required field</div>
                                            <div slot="pattern">Transporter contact no. is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.transportSupervisorName)">
                                        <label>Transport Supervisor Name</label>
                                        <input type="text" name="transportSupervisorName" class="form-control" required v-model.lazy="vehicle.transportSupervisorName" placeholder="Transport Supervisor Name">
                                        <field-messages name="transportSupervisorName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Supervisor Name is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.transportSupervisorContact)">
                                        <label>Transport Supervisor Contact</label>
                                        <input type="number" name="transportSupervisorContact" class="form-control" required v-model.lazy="vehicle.transportSupervisorContact" placeholder="Transport Supervisor Contact" pattern="[78965][0-9]{9}">
                                        <field-messages name="transportSupervisorContact" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Supervisor Contact is a required field</div>
                                            <div slot="pattern"> Supervisor Contact no. is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.ownerDetails)">
                                        <label>Transporter Address</label>
                                        <textarea class="form-control" name="ownerDetails" v-model.lazy="vehicle.ownerDetails" placeholder="Other Info">
                                        </textarea>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.permitDetails)">
                                        <label>Permit Details</label>
                                        <input type="text" name="permitDetails" class="form-control" v-model.lazy="vehicle.permitDetails" placeholder="Permit Details">
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.billingInfo)">
                                        <label>Billing Info</label>
                                        <input type="text" name="billingInfo" class="form-control" v-model.lazy="vehicle.billingInfo" placeholder="Billing Info">
                                    </validate>
                                </div>                                
                            </div>
                            <div class="col-sm-12">                                
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.otherInfo)">
                                        <label>Other Info</label>
                                        <textarea class="form-control" name="otherInfo" v-model.lazy="vehicle.otherInfo" placeholder="Other Info">
                                        </textarea>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select required v-model="vehicle.status" name="status" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status date is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>                                
                                <div class="col-sm-3">
                                    <label></label>
                                    <div class="mt">
                                        <validate class="form-group inline" :class="fieldClassName(formstate.cgpsMonitoring)">
                                            <label class="checkbox-inline"><input type="checkbox" v-model.lazy="vehicle.camera" :checked="vehicle.camera" value="false" name="camera">Camera</label>
                                        </validate>
                                        <validate class="form-group inline" :class="fieldClassName(formstate.camera)">
                                            <label class="checkbox-inline"><input type="checkbox" v-model.lazy="vehicle.cgpsMonitoring" :checked="vehicle.cgpsMonitoring" value="false" name="cgpsMonitoring">GPS Monitoring</label>
                                        </validate>
                                    </div> 
                                </div>                                
                            </div>                                                
                        </vue-form>
                        <div class="col-sm-12 text-right" >
                            <router-link :to="{ name: 'Vehicle' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateVehicle" :disabled="!(formstate.$dirty && formstate.$valid)" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]">Update Vehicle</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>         

<script>
  import { formService, eventBus , vehicleService} from '../../../services'
  import { EVENTS } from '../../../config'
  import swal from 'sweetalert2'
  import { USER_ROLES } from '../../../config';
    import { mapState } from 'vuex';


  export default {
    name: 'VehicleDetail',
    data () {
        return {
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list : {},
            vehicle : {
                status : 'active'
            }
        }
    },
    mounted: function() {
        this.getRegionList()
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        getVehicle () {
            return this.$vehicleDataRepository.find(this.$route.params._id)
            .then((response) => {
                this.vehicle = response.data;
            })
            .catch((error) => {
                console.error('Region.GetVehicleFunction-error:', error)
                this.$snotify.error('Get Vehicle detail failed', 'Error!')
            })
        },
        validateRegistration : function(e) {
            let keyCode = e.keyCode || e.which;
            if (keyCode == 32)
                e.preventDefault();
            else 
                this.vehicle = {
                    ...this.vehicle,
                    regNo : e.target.value.toUpperCase()
                }
        },
        getRegionList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if(this.user.roleName == "GA Head"){
                params.regionManager = this.user._id
            }
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        });                       
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                });
        },
        updateVehicle () {
            this.loading = true;
            return vehicleService.updateVehicle(this.vehicle)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Vehicle updated!', 'Success!')
                this.$router.push('/vehicle')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('vehicle Add failed! Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'New vehicle add is failed.Please try again!'
                }
            })
        },
        deleteVehicleModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Vehicle!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: 'swal-modal2',
                width: '400px',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteVehicle()
                }
            })
        },
        deleteVehicle () {
            this.loading = true
            return this.$vehicleDataRepository.deleteOne(this.vehicle._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Vehicle has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/vehicle')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete vehicle failed', 'Error!')
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }
    },
    created() {
        const promises = []
        this.loading = true
        promises.push(this.getVehicle())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(error => {
                this.loading = false;
                this.$snotify.error('Create vehicle failed', 'Error!');
            })
    },
    computed:{
        ...mapState({
            user:state=>state.auth.user,
        })
    }
  }
</script>
<style scoped>
    .required-field > label::after  {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .mt {
        margin-top: 7px;
    }
    .swal-text{
     font-size: 100px !important;
}
.gradientbt{
    background: #0F6940;
        color: white
}
</style>



// WEBPACK FOOTER //
// VehicleDetail.vue?75789ed2